// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero-module--hero--3OE-D","heroInner":"hero-module--heroInner--2ehU4","title":"hero-module--title--ZIWVe"};